import {LIKE_REACTION_ICON} from '../../static/reactions/like-icon'
import {LOVE_REACTION_ICON} from '../../static/reactions/love-icon'
import {EXCELLENT_REACTION_ICON} from '../../static/reactions/excellent-icon'
import {INTERESTING_REACTION_ICON} from '../../static/reactions/interesting-icon'
import Isotype from '../../static/reactions/Isotype.svg'
import {LIKE_ICON} from '../../ui-kit/helpers/icons/like'
import {HEART_ICON} from '../../ui-kit/helpers/icons/heart'
import {CLAP_ICON} from '../../ui-kit/helpers/icons/clap'
import {SPOTLIGHT_ICON} from '../../ui-kit/helpers/icons/spotlight'

export const reactionsArray = ['LIKE', 'LOVE', 'EXCELLENT', 'INTERESTING', 'PROUD']

export const reactionsData = {
  LIKE: {
    name: 'like',
    title: 'Me gusta',
    graphic: LIKE_REACTION_ICON,
    icon: LIKE_ICON,
  },
  LOVE: {
    name: 'love',
    title: 'Me encanta',
    graphic: LOVE_REACTION_ICON,
    icon: HEART_ICON,
  },
  EXCELLENT: {
    name: 'excellent',
    title: 'Excelente',
    graphic: EXCELLENT_REACTION_ICON,
    icon: CLAP_ICON,
  },
  INTERESTING: {
    name: 'interesting',
    title: 'Interesante',
    graphic: INTERESTING_REACTION_ICON,
    icon: SPOTLIGHT_ICON,
  },
  PROUD: {
    name: 'proud',
    title: 'Me enorgullece',
    graphic: Isotype,
    icon: Isotype,
  },
}
